// import _ from 'lodash'
import accountApi from '@/api/account'

const state = {
  justSignUp: false,
  userData: null
}

const getters = {
  userData: state => state.userData,
  justSignUp: state => state.justSignUp,
  isAdminUser: state => state.userData && state.userData.roleCode === 1
}

const mutations = {
  setUserData (state, data) {
    state.userData = data
  },
  setJustSignUp (state, value) {
    state.justSignUp = value
  },
  clearUserData (state) {
    state.userData = null
  }
}

const actions = {
  fetchUserData (context) {
    return accountApi.find()
      .then(response => {
        const data = response.data
        context.commit('setUserData', data)
        return data
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js